import { render } from "./quoteDialog.vue?vue&type=template&id=871464e8&scoped=true"
import script from "./quoteDialog.vue?vue&type=script&lang=js"
export * from "./quoteDialog.vue?vue&type=script&lang=js"

import "./quoteDialog.vue?vue&type=style&index=0&id=871464e8&lang=scss"
import "./quoteDialog.vue?vue&type=style&index=1&id=871464e8&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-871464e8"]])

export default __exports__